<template>
    <div class="ap-drop-zone" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive" @drop.prevent="onDrop">
        <slot :dropZoneActive="active"></slot>
    </div>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    const emit = defineEmits(['files-dropped'])

    let active = ref(false)
    let inActiveTimeout = null

    function setActive() {
        active.value = true
        clearTimeout(inActiveTimeout)
    }

    function setInactive() {
        inActiveTimeout = setTimeout(() => {
            active.value = false
        }, 50)
    }

    function onDrop(e) {
        setInactive()
        emit('files-dropped', [...e.dataTransfer.files])
    }

    function preventDefaults(e) {
        e.preventDefault()
    }

    const events = ['dragenter', 'dragover', 'dragleave', 'drop']

    onMounted(() => {
        events.forEach((eventName) => {
            document.body.addEventListener(eventName, preventDefaults)
        })
    })

    onUnmounted(() => {
        events.forEach((eventName) => {
            document.body.removeEventListener(eventName, preventDefaults)
        })
    })
</script>

<style lang="scss">
    .ap-drop-zone {
        position: relative;
        padding: 18px 0 5px;
        text-align: center;
        clear: both;
        border-radius: 3px;
        background: linear-gradient(to right, #c8d7e1 40%, transparent 60%),linear-gradient(to right, #c8d7e1 40%, transparent 60%),linear-gradient(to bottom, #c8d7e1 40%, transparent 60%),linear-gradient(to bottom, #c8d7e1 40%, transparent 60%),#fff;
        background-position: bottom left 3px,top left 3px,right,left;
        background-size: 8px 1px,8px 1px,1px 8px,1px 8px;
        background-repeat: repeat-x,repeat-x,repeat-y,repeat-y;
    }
</style>